import { useMemo, useRef } from 'react';
const DEFAUL_EMPTY_ITEM = {
    label: '',
    value: '',
};
export const useSelect = (props) => {
    const { items, itemEmpty, defaultValue, value } = props;
    const emptyItem = useMemo(() => items.find(itemEmpty), [items, itemEmpty]);
    const defaultItemRef = useRef(defaultValue !== undefined
        ? (items.find((item) => item.value === defaultValue) ?? undefined)
        : value !== undefined
            ? defaultValue
            : emptyItem);
    const selectedItem = useMemo(() => value !== undefined
        ? (items.find((item) => item.value === value) ??
            emptyItem ??
            DEFAUL_EMPTY_ITEM)
        : undefined, [items, value, emptyItem]);
    return {
        defaultItem: defaultItemRef.current,
        selectedItem,
    };
};
